import { Notification } from '../../../../../models/Notification'
import { StylesScene } from '../../../../../models/Story'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserReadItemStyles = {
    [key: string]: StylesScene
}
const UserReadItemStyles: TUserReadItemStyles = {
    'Group': {
        
    },
    'Public': {
        docTitle: {
            container: {
                position: 'absolute',
                top: 700,
                right: 28,
                transform: 'rotate(-12deg)',
                padding: '6px',
                borderRadius: 4,
                zIndex: 2,
                backgroundColor: '#fff',
                maxHeight: 125,
                maxWidth: 240
            },
            text: {
                fontFamily: 'Rubik',
                fontSize: 24,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.5,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#0e0e14',
            }
        },
        mainImg: {
            container: {
                width: 320,
                height: 391,
                position: 'absolute',
                top: 112,
                right: 32,
                transform: 'rotate(2deg)',
            }
        },
        dataTypeTitle: {
            container: {
                top: 648,
                right: 42,
                position: 'absolute',
                transform: 'rotate(4deg)',
            },
            text: {
                textTransform: 'lowercase',
                opacity:.9,
                fontSize: 20,
                fornWeight: 500,
                color: '#fff',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
            }
        },
        avatar: {
            container: {
                width: 48,
                height: 48,
                borderRadius: '100%',
                overflow: 'hidden',
                position: 'absolute',
                top: 640,
                left: 294,
            }
        },
        secondaryImg: {
            container: {
                position: 'absolute',
                width: 200,
                height: 88,
                top: 590,
                left: 33
            }
        },
        staticConfirmed: {
            container: {
                position: 'absolute',
                left: 40,
                top: 276 
            },
            text: {
                fontSize: 32,
                color: '#fff',
                fontWeight: 'bold',
                fontFamily: 'Roboto Slab',
                lineHeight: 1.81,
                letterSpacing: 1,
                textShadow: '2px 2px 2px rgba(0, 0, 0, 1)',
            }
        },
        staticConfirmedSecondary: {
            container: {
                position: 'absolute',
                left: 135,
                top: 437,
                padding: '25px 42px',
                borderRadius: 6,
                backgroundColor: '#0e0e14'
            },
            text: {
                color: '#fff',
                fontSize: 36,
                fontWeight: 500,
            }
        }
    }
}

export const getUserReadItemBackground = (notif: Notification): [string, StylesScene] => {
    return [getNotificationImgPathes(notif.systemActionTypeUid)[notif.groupType], UserReadItemStyles[notif.groupType]]
}